import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as ModalType from 'storyboard/constants/modal-type';
import {t} from 'common/utils/translation-util';

export const CLASS_NAME = 'EditThemeButton';

class StoryboardThemeButtonContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    openModal: PropTypes.func,
  };

  static defaultProps = {
    dispatch: () => {},
    openModal: () => {},
  };

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  UNSAFE_componentWillMount() {
    // In the edit view, there is a substantial Edit Theme
    // button to the top-left of the storyboard. There
    // also exists an Edit Theme option in the actions
    // dropdown at the top of the page. Both these
    // elements live outside of the Storyboard React app.
    // This container obtains references to them and
    // assigns event listeners.
    Array.from(document.getElementsByClassName(CLASS_NAME)).forEach(
      (element) => {
        element.addEventListener('click', this.handleClick);
      },
    );
  }

  componentWillUnmount() {
    Array.from(document.getElementsByClassName(CLASS_NAME)).forEach(
      (element) => {
        element.removeEventListener('click', this.handleClick);
      },
    );
  }

  render() {
    // This container is unusual because the component
    // that it contains is added to the page at the
    // templating stage, outside the React world.
    // So we return null from render, and listen to
    // the document element directly.
    return null;
  }

  handleClick(event) {
    event.preventDefault();
    this.props.openModal(ModalType.EDIT_THEME, t('Edit theme'));
  }
}

export default connect()(StoryboardThemeButtonContainer);
